define((require, exports, module) => {
    'use strict';

    const blackList = [
        /@0815\.ru/i,
        /@0815\.su/i,
        /@0mixmail\.info/i,
        /@10mail\.org/i,
        /@1shivom\.com/i,
        /@20boxme\.org/i,
        /@2emailock\.com/i,
        /@6-6-6\.flu\.cc/i,
        /@6-6-6\.igg\.biz/i,
        /@6-6-6\.nut\.cc/i,
        /@6-6-6\.usa\.cc/i,
        /@69postix\.info/i,
        /@absolutesuccess\.win/i,
        /@affiliate-nebenjob\.info/i,
        /@affilikingz\.de/i,
        /@anonmail\.top/i,
        /@anonymailer\.net/i,
        /@anonymousemail\.me/i,
        /@armyspy\.comcuvox\.de/i,
        /@art-en-ligne\.pro/i,
        /@ausgefallen\.info/i,
        /@blinkme\.ru/i,
        /@btcmail\.pw/i,
        /@camping-grill\.info/i,
        /@carins\.io/i,
        /@click-email\.com/i,
        /@cool\.fr\.nf/i,
        /@courriel\.fr\.nf/i,
        /@cryp\.email/i,
        /@crypemail\.info/i,
        /@cyber-innovation\.club/i,
        /@cyber-phone\.eu/i,
        /@daily-email\.com/i,
        /@dayrep\.com/i,
        /@dayrep\.comeinrot\.com/i,
        /@digitalesbusiness\.info/i,
        /@discard\.email/i,
        /@discardmail\.com/i,
        /@discardmail\.de/i,
        /@disign-concept\.eu/i,
        /@disign-revelation\.com/i,
        /@dropmail\.me/i,
        /@ecolo-online\.fr/i,
        /@email-24x7\.com/i,
        /@emailate\.com/i,
        /@emailay\.com/i,
        /@emailtex\.com/i,
        /@emltmp\.com/i,
        /@endrix\.org/i,
        /@estate-invest\.fr/i,
        /@fast-mail\.fr/i,
        /@fleckens\.hu/i,
        /@freelance-france\.eu/i,
        /@freundin\.ru/i,
        /@getnada\.com/i,
        /@grr\.la/i,
        /@guerrillamail\.biz/i,
        /@guerrillamail\.com/i,
        /@guerrillamail\.de/i,
        /@guerrillamail\.info/i,
        /@guerrillamail\.net/i,
        /@guerrillamail\.org/i,
        /@guerrillamailblock\.com/i,
        /@gustr\.com/i,
        /@hartbot\.de/i,
        /@hubii-network\.com/i,
        /@hulapla\.de/i,
        /@incognitomail\.org/i,
        /@instantmail\.fr/i,
        /@jet-renovation\.fr/i,
        /@jetable\.fr\.nf/i,
        /@jourrapide\.com/i,
        /@just-email\.com/i,
        /@kikoxltd\.com/i,
        /@kiryubox\.cu\.cc/i,
        /@klick-tipp\.us/i,
        /@knol-power\.nl/i,
        /@kumail8\.info/i,
        /@last-chance\.pro/i,
        /@mail-easy\.fr/i,
        /@mail2\.space/i,
        /@mail4-us\.org/i,
        /@mail707\.com/i,
        /@mailcatch\.com/i,
        /@mailforspam\.com/i,
        /@mailinator\.com/i,
        /@mailmetal\.com/i,
        /@mailsoul\.com/i,
        /@mainerfolg\.info/i,
        /@mega\.zik\.dj/i,
        /@mintemail\.com/i,
        /@moncourrier\.fr\.nf/i,
        /@monemail\.fr\.nf/i,
        /@monmail\.fr\.nf/i,
        /@mt2015\.com/i,
        /@mvrht\.net/i,
        /@mytempemail\.com/i,
        /@no-spam\.ws/i,
        /@nomail\.xl\.cx/i,
        /@nospam\.ze\.tc/i,
        /@pay-mon\.com/i,
        /@pfui\.ru/i,
        /@photo-impact\.eu/i,
        /@pokemail\.net/i,
        /@premium-mail\.fr/i,
        /@reality-concept\.club/i,
        /@reg19\.ml/i,
        /@rhyta\.com/i,
        /@s-s\.flu\.cc/i,
        /@s-s\.igg\.biz/i,
        /@s-s\.nut\.cc/i,
        /@s-s\.usa\.cc/i,
        /@s0ny\.net/i,
        /@send22u\.info/i,
        /@sharklasers\.com/i,
        /@skymailgroup\.com/i,
        /@smashmail\.de/i,
        /@sohai\.ml/i,
        /@solar-impact\.pro/i,
        /@spam4\.me/i,
        /@spambog\.com/i,
        /@spambog\.de/i,
        /@spambog\.ru/i,
        /@speed\.1s\.fr/i,
        /@superrito\.com/i,
        /@sweetxxx\.de/i,
        /@teewars\.org/i,
        /@teleworm\.us/i,
        /@temp-mail\.org/i,
        /@tempemail\.net/i,
        /@tempinbox\.com/i,
        /@tempr\.email/i,
        /@theanonymousemail\.com/i,
        /@trashmail\.com/i,
        /@travala10\.com/i,
        /@trbvm\.com/i,
        /@u14269\.ml/i,
        /@ugimail\.net/i,
        /@used-product\.fr/i,
        /@virgilio\.it/i,
        /@vmani\.com/i,
        /@wazabi\.club/i,
        /@web-ideal\.fr/i,
        /@webcontact-france\.eu/i,
        /@wikidocuslava\.ru/i,
        /@wimsg\.com/i,
        /@xidikumail8\.info/i,
        /@yomail\.info/i,
        /@yopmail\.com/i,
        /@yopmail\.fr/i,
        /@yopmail\.net/i,
        /@youzend\.net/i,
        /@zaktouni\.fr/i,
        /@zippiex\.com/i,
    ];

    function isEmailBlackListed(email) {
        return blackList.some((regExp) => {
            return regExp.test(email);
        });
    }

    module.exports = isEmailBlackListed;
});
